/* START_MODULE_CONTRACT
 * PURPOSE: Общая левая панель (hero) для страниц входа и регистрации.
 * SCOPE: Бренд, заголовок и декоративная сетка планирования.
 * DEPENDS: LoginPlanningGrid
 * LINKS: M-FE-AUTH
 * ROLE: RUNTIME
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * AuthPageHero - split-layout hero для публичных auth-страниц.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Вынесен общий hero для login и register.
 * END_CHANGE_SUMMARY
 */

import LoginPlanningGrid from './LoginPlanningGrid';

/* START_METHOD_AuthPageHero */
/* START_CONTRACT: AuthPageHero
 * PURPOSE: Отрисовать брендированную левую колонку auth-страниц.
 * INPUTS: нет.
 * OUTPUTS: { JSX.Element }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-AUTH
 * END_CONTRACT: AuthPageHero
 */
export default function AuthPageHero() {
  return (
    <section className="auth-page__hero" aria-label="О TeamPlanner">
      <p className="auth-page__brand">TeamPlanner</p>
      <h1 className="auth-page__headline">
        Планировщик времени команд разработки ПО
      </h1>
      <div className="auth-page__grid-wrap">
        <LoginPlanningGrid />
      </div>
    </section>
  );
}
/* END_METHOD_AuthPageHero */
